import React from "react";
import { motion } from "framer-motion";
import jobique from "../assets/Sri-balaji_project.png";

const Card6 = () => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      className="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg bg-gray-100 dark:border-gray-700 my-8"
    >
      <a
        href="https://sri-balaji-traders-1.web.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="rounded-t-lg w-full"
          src={jobique}
          alt="Sri Balaji Traders project home page"
        />
      </a>
      <div className="p-5">
        <a
          href="https://github.com/Vinay50029/sri-balaji-rice-website"
          target="_blank"
          rel="noopener noreferrer"
        >
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black hover:text-blue-500 transition-colors duration-300 cursor-pointer">
            Sri Balaji Traders
          </h5>
        </a>
        <p className="mb-3 font-normal text-gray-700 dark:text-black-400">
          Co-developed this production-ready retail platform for my father's family business in collaboration with my brother. Architected using React and Firebase, it supports dynamic catalogs and location-based delivery workflows. Integrated an AI support assistant while validating code for security, performance, and maintainability.
        </p>
      </div>
    </motion.div>
  );
};

export default Card6;
